export function getUser() {
    try {
        return JSON.parse(localStorage.getItem('user') ?? 'null');
    } catch {
        return null;
    }
}
